export default function AgreePrivacy(){
    return(
        <div className="agreePrivacyPage_inner">
            <h2 className="agreePrivacyPageTitle">개인정보 수집 / 이용 동의 약관</h2>

                <div className="agreePrivacyContent" dangerouslySetInnerHTML={{__html: `
이 사이트는 인피니티커넥트가 제공하고 있는 운세 서비스입니다.
수집하는 개인정보의 항목 및 수집방법

가. 수집하는 개인정보의 항목

첫째, 회사는 원활한 고객상담,각종 서비스의 제공을 위해 최소한의 개인정보를 필수항목으로 수집하고 있습니다.
- 이름, 생년월일, 생시, 성별, 양/음력

둘째, 서비스 이용과정이나 사업처리 과정에서 아래와 같은 정보들이 자동으로 생성되어 수집될 수 있습니다.
- 방문 일시, 서비스 이용 기록, 불량 이용 기록

나. 개인정보 수집방법

회사는 다음과 같은 방법으로 개인정보를 수집합니다.

- 홈페이지 (제공되는 운세 페이지 : 직접입력)

다.개인정보의 보유 및 이용기간

이용자의 입력하신 개인정보는 고객이 정보 삭제시까지 유지 됩니다.
1)보존 이유:운세컨텐츠 이용 및 부정 이용 방지
2)보존 기간:운세서비스를 이용하는 고객이 정보 삭제시까지

콘텐츠에 대한 저작권 및 법적 책임은 인피니티커넥트에 있습니다.  `
    }}
                />
        </div>
    )
}
